import { Warehouse } from "@phosphor-icons/react"
import Select from "~/components/reusable/Select"
import { type IWarehouse } from "~/models/warehouses"

type WarehouseSelectorProps = {
  warehouses: IWarehouse[] | undefined
  warehouseIds: string[]
  setWarehouseIds: (ids: string[]) => void
  warehouseQuantity?: (id: string) => number
  className?: string
  clearable?: boolean
  labelAsPlaceholder?: boolean
  placeholder?: string
  size?: "base" | "sm"
  isMulti?: boolean
}

export function WarehouseSelector({
  warehouses,
  warehouseIds,
  setWarehouseIds,
  warehouseQuantity,
  className = "w-[230px]",
  clearable = false,
  labelAsPlaceholder = false,
  placeholder = "Warehouse",
  size = "base",
  isMulti = false,
}: WarehouseSelectorProps) {
  return (
    <Select
      label={!labelAsPlaceholder ? "Warehouse" : undefined}
      placeholder={labelAsPlaceholder ? placeholder : undefined}
      className={className}
      onChange={(value) => {
        if (value === null) {
          // When selection is cleared, set warehouseIds to an empty array
          setWarehouseIds([])
        } else if (value !== undefined) {
          // Handle both single and multi-selection
          const selectedValues = Array.isArray(value) ? value : [value]
          setWarehouseIds(selectedValues.map((x) => x?.id))
        }
      }}
      value={warehouses?.filter((warehouse) => warehouseIds.includes(warehouse.id)) ?? []}
      options={(warehouses ?? []).filter((wh) => wh.isPrimary)}
      getOptionLabel={(option) =>
        warehouseQuantity
          ? `${option.name} (units added: ${warehouseQuantity(option.id)})`
          : option.name
      }
      getOptionValue={(option) => option.id}
      isDisabled={(warehouses ?? []).length === 1}
      isMulti={isMulti}
      isClearable={clearable}
      size={size}
      leftIcon={<Warehouse />}
    />
  )
}
